import { map, startWith } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { saveAs } from 'file-saver-es';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { VendorPaymentService } from '../../../services/vendor-payment.service';
import { MatDialog } from '@angular/material/dialog';
import { VendorService } from '../../../services/vendor.service';
import { INVOICE_TYPE } from '../../../model/constant';
import { FuelchargepaymentdetailsComponent } from '../../theme/fuelchargepaymentdetails/fuelchargepaymentdetails.component';
import { WorkorderpaymentdetailsComponent } from '../../theme/workorderpaymentdetails/workorderpaymentdetails.component';
import { VendorPaymentDelailsComponent } from '../../theme/vendorpaymentdetails/vendor-payment-delails.component';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { ToastrService } from "ngx-toastr";
import * as _ from "lodash";
import { InvoiceService } from '../../../services/invoice.service';
import { CustomersService } from '../../../services/customers.service';

@Component({
  selector: 'app-sales-reports',
  templateUrl: './sales-reports.component.html',
  styleUrls: ['./sales-reports.component.scss'],
  providers: [VendorPaymentService, CustomersService],
})
export class SalesReportsComponent implements OnInit {

  reports = [];
  searchForm: UntypedFormGroup;
  customerdata = []
  customerNameIdMap = {}
  filteredCustomers: any = []
  type = "";
  invoiceNo = ""
  customerId = "";
  customer = "";
  fromDate = "";
  toDate = "";
  readonly allowedPageSizes = [20, 50, 100, "all"];
  vendorNameIdMap = {};
  loadingVisible = false;
  constructor(
    private invoiceService: InvoiceService,
    public dialog: MatDialog,
    private _customersservice: CustomersService,
    private formBuilder: UntypedFormBuilder,
  ) { }

  ngOnInit() {
    this.searchFormBuild();
    this.onReportSearch();
    this.getCustomerdata();
  }
  onReportSearch() {
    this.loadingVisible = true;
    this.searchForm = this.formBuilder.group({
      customer: [this.customer],
      customerId: [this.customerId],
      fromDate: [this.fromDate],
      toDate: [this.toDate],
      type: [this.type],
      invoiceNo: [this.invoiceNo]
    }, {});
    console.log(this.searchForm.value);
    this.getData(this.searchForm.value);

  }
  onReportReset() {
    this.searchFormBuild();
    this.getData(this.searchForm.value);
  }
  searchFormBuild() {
    this.searchForm = this.formBuilder.group({
      customer: [''],
      customerId: [''],
      fromDate: [''],
      toDate: [''],
      type: [''],
      invoiceNo: [''],
    }, {});
    this.customer = "";
    this.customerId = "";
    this.fromDate = "";
    this.toDate = "";
    this.type = "";
    this.invoiceNo = "";
  }
  getCustomerdata() {
    this.customerdata = [];
    this._customersservice.getCustomersData().subscribe((data) => {
      for (var i = 0; i < data.result.length; i++) {
        if (data.result[i].name != undefined) {
          this.customerdata.push(data.result[i]);
          console.log(this.customerdata);
          this.customerNameIdMap[data.result[i].name] = data.result[i]._id;
          console.log(this.customerNameIdMap);
        }
      }
    });
    this.filteredCustomers = this.customerdata;
    /* this.filteredCustomers = this.searchForm.get("customer")!.valueChanges.pipe(
      startWith(""),
      map((value: any) => this._filter(value))
    ); */
  }
  private _filter(value: string): string[] {
    if (value != "") {
      const filterValue = value.toLowerCase().replace(/[\W_]/g, "");
      return this.customerdata.filter((option) =>
        option.name.toLowerCase().replace(/[\W_]/g, "").includes(filterValue)
      );
    } else {
      return this.customerdata;
    }
  }
  onCustomerChange(value) {
    if (value != "") {
      const filterValue = value.toLowerCase().replace(/[\W_]/g, "");
      this.filteredCustomers = this.customerdata.filter((option) =>
        option.name.toLowerCase().replace(/[\W_]/g, "").includes(filterValue)
      );
    } else {
      this.filteredCustomers = this.customerdata;
    }
  }
  // regular,
  // cancelled

  isCustomerSelected = false
  onCustomerSelected(customerName) {
    if (customerName != "") {
      this.searchForm.get("customerId").setValue(this.customerNameIdMap[customerName]);
      this.customerId = this.customerNameIdMap[customerName];
      this.isCustomerSelected = true;
      console.log(this.searchForm.value);
    }
  }
  details(payment) {
    let dialogConfig = Object.assign(
      { width: "1000px" },
      { data: payment },
      { disableClose: false }
    );
    switch (payment.billType) {
      case INVOICE_TYPE.FUEL_CHARGE:
        let fuelChargeDetailsDialogRef = this.dialog.open(
          FuelchargepaymentdetailsComponent,
          dialogConfig
        );
        fuelChargeDetailsDialogRef.afterClosed().subscribe((data) => {
          if (data == null) {
            // this.getData();
          } else {
          }
        });
        break;
      case INVOICE_TYPE.WORK_ORDER:
        let workorerDetailsDialogRef = this.dialog.open(
          WorkorderpaymentdetailsComponent,
          dialogConfig
        );
        workorerDetailsDialogRef.afterClosed().subscribe((data) => {
          if (data == null) {
            // this.getData();
          } else {
          }
        });
        break;

      default:
        let editDialogRef = this.dialog.open(
          VendorPaymentDelailsComponent,
          dialogConfig
        );
        editDialogRef.afterClosed().subscribe((data) => {
          if (data == null) {
            // this.getData();
          } else {
          }
        });
        break;
    }
  }

  getData(searchOptions) {
    this.searchForm = this.formBuilder.group({
      customer: [''],
      customerId: [''],
      fromDate: [''],
      toDate: [''],
      type: ['']
    }, {});

    console.log("object selected", searchOptions, this.customerId);

    this.invoiceService.getInvoiceReportList(searchOptions).subscribe((data) => {
      console.log(data.result);
      this.reports = data.result;

      let postedInvoiceQuery = {};
      if (searchOptions?.customerId) {
        let customerInfo = this.customerdata.find((customer) => customer?._id == searchOptions?.customerId);
        console.log(customerInfo);
        postedInvoiceQuery["customerId"] = customerInfo?.ErpEntityNo;
      }
      if (searchOptions?.type) {
        if (searchOptions?.type == 'regular') {
          postedInvoiceQuery["cancelled"] = false;
        }
        else if (searchOptions?.type == 'cancelled') {
          postedInvoiceQuery["cancelled"] = true;
        }
      }
      if (searchOptions?.invoiceNo) {
        postedInvoiceQuery["invoiceId"] = searchOptions?.invoiceNo;
      }
      if (searchOptions?.fromDate) {
        postedInvoiceQuery["fromDate"] = searchOptions?.fromDate;
      }
      if (searchOptions?.toDate) {
        postedInvoiceQuery["toDate"] = searchOptions?.toDate;
      }
      this.invoiceService.getBCpostedInvoiceList(postedInvoiceQuery).subscribe((data1) => {
        console.log(data1.result);

        const existingInvoiceIds = new Set(this.reports.map(report => report.invoiceId));

        for (let i = 0; i < data1.result.length; i++) {
          const invoice = data1.result[i];

          if (!existingInvoiceIds.has(invoice.No)) { // Skip if the invoice already exists in reports
            let postedInvoiceOrder = {
              invoiceId: invoice.No,
              customerName: invoice?.Sell_to_Customer_Name,
              createdAt: invoice?.Posting_Date,
              invoiceAmount: invoice?.Cancelled ? invoice?.Amount_Including_VAT * -1 : invoice?.Amount_Including_VAT,
              paidAmount: invoice?.Cancelled ? 0 : invoice?.Amount_Including_VAT - invoice?.Remaining_Amount,
              remainingAmount: invoice?.Cancelled ? 0 : invoice?.Remaining_Amount,
              bcCreatedAt: invoice.CreatedAt
            };
            console.log(postedInvoiceOrder);
            this.reports.push(postedInvoiceOrder);
          }
        }
        this.reports.sort((a, b) => {
          const dateA = new Date(a.createdAt || a.bcCreatedAt).getTime();
          const dateB = new Date(b.createdAt || b.bcCreatedAt).getTime();
          return dateB - dateA; // Sort descending (newest first)
        });
        this.loadingVisible = false;

      }, (error) => {
        this.loadingVisible = false;
      });
    });
  }





  onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Expense History");
    var date = new Date();
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();
    const hh = date.getHours().toString();
    const min = date.getMinutes().toString();
    const sec = date.getSeconds().toString();
    const dateFormat =
      yyyy +
      "-" +
      (mm[1] ? mm : "0" + mm[0]) +
      "-" +
      (dd[1] ? dd : "0" + dd[0]) +
      " " +
      hh +
      "_" +
      min +
      "_" +
      sec;

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          `Sales Report - ${dateFormat}.xlsx`
        );
      });
    });
    e.cancel = true;
  }
}
